import {isValid, parseISO, format} from 'date-fns'
import {useEffect, useState} from 'react'

export const useFormatPreview = (isoDate: string, formatString?: string) => {
  const [valid, setValid] = useState<boolean>()
  const [formatted, setFormatted] = useState<string>(isoDate)

  useEffect(() => {
    const date = isoDate ? parseISO(isoDate) : new Date()
    let formatted = ''
    if (formatString && isValid(date)) {
      try {
        formatted = format(date, formatString)
        setValid(true)
      } catch (e) {
        setValid(false)
      }
    }
    setFormatted(formatted)
  }, [isoDate, formatString])

  return {formatted, valid}
}
